import { IRowData } from "@multiweb/types/contracts";
import { IAttrStringValue } from "../../../../Global/Base/DataTypes/IAttrValue";
import { OWDate } from "../../../../Global/Base/DataTypes/OWDate";
import { DateUtils } from "../../../../Global/Base/Utils/DateUtils";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { OWDateTime } from "../../../../OW.Remoting/Remoting/DataTypes/OWDateTime";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { UIManager } from "../../../UI/UI/UIManager";
import { IDataGrid } from "../../IDataGrid";
import { IDataRowElement } from "./IDataRow";
import { TableCell } from "./TableCell";
import { TreeViewDataRow } from "./TreeViewDataRow";

export class GroupingTreeViewDataRow extends TreeViewDataRow {
    //#region Fields
    /** Atribut, zobrazovaný na daném řádku */
    private _dataAttribute: string;
    //#endregion Fields

    //#region Properties
    /** Rodič, ve kterém je vložen aktuální řádek nebo null */
    public override get parentRow(): GroupingTreeViewDataRow {
        if (this.parentElement && this.parentElement.parentElement instanceof GroupingTreeViewDataRow) {
            return this.parentElement.parentElement;
        }

        return null;
    }

    public override get childRows(): GroupingTreeViewDataRow[] {
        if (!this._childrenElement)
            return [];

        return Array.from(this._childrenElement.children) as GroupingTreeViewDataRow[];
    }

    /**
     * Raw data do podmínky pro filtrování seznamu
     */
    public dataValue: any;

    /**
     * Atribut, ze kterého byly vyčteny data pro konkrétní řádek
     */
    public get dataAttribute(): string {
        return this._dataAttribute;
    }

    /**
     * Atribut, ze kterého byly vyčteny data pro konkrétní řádek
     */
    public set dataAttribute(v: string) {
        this._dataAttribute = v;
        this.setAttribute("data-attribute", v);
    }
    //#endregion Properties

    //#region Constructor
    constructor(self?: any) {
        super(self);
    }
    //#endregion Constructor

    //#region Methods
    /**
     * Ziniciuje nový řádek
     * @param rowData Data k zobrazení v řádku
     * @param ownerGrid DataGrid, ke kterému řádek patří
     */
    public override init(rowData: IRowData, ownerGrid: IDataGrid<IDataRowElement>): void {
        this._dataGrid = ownerGrid;
        this._dataCells = new Array<TableCell>();
        this.dataAttribute = rowData.attribute.toString();
        this.dataKey = UIManager.instance.generateElementID();
        const data = AttrValueReader.readRow(rowData, this.dataAttribute, [IAttrStringValue]);

        if (data != null) {
            if (data instanceof Date || data instanceof OWDate) {
                this.dataValue = DateUtils.dateToString(data, "s");
            } else if (data instanceof OWDateTime) {
                this.dataValue = DateUtils.dateToString(data.getJsDate(), "s");
            } else {
                this.dataValue = data;
            }
        }
        this._dataCells.push(new TableCell(this._dataGrid, this, 0, this._dataGrid.columns[0], [data]));

        if (!rowData.hasChildren) {
            this.isLastNode = true;
        }
    }

    /**
     * Zobrazí řádek s daty
     */
    public override render(): HTMLElement {
        for (const cell of this._dataCells) {
            const newCell = cell.render();

            if (newCell) {
                this._dataElement.appendChild(newCell);
            }
        }

        return this as HTMLElement;
    }
    //#endregion Methods
}

registerCustomElement("tsc-GroupingTreeViewDataRow", GroupingTreeViewDataRow);
